import React from 'react';

import ConfirmationModal from 'components/V2/ConfirmationModal';
import {
  ACH_MANDATE_CONSENT_TEXT_PREFIX,
  ACH_MANDATE_CONSENT_TEXT_SUFFIX,
} from 'helpers/payment';
import './AchMandateModal.scss';

// Shown immediately before the Plaid flow starts, so the operator authorizes
// ACH debits for the account they are about to connect. Agreeing here is what
// lets the payment method be saved (see EditPaymentScene#enableSubmit) and is
// recorded against the user once the payment method is submitted.
const AchMandateModal = ({ isOpen, toggle, onAccept }) => (
  <ConfirmationModal
    isOpen={isOpen}
    toggle={toggle}
    title="ACH Payment Authorization"
    htmlBody
    body={
      <div className="ach-mandate-modal-body">
        <p className="ach-mandate-modal-instructions">
          Before connecting a bank account, please review and agree to the following
          authorization:
        </p>
        <p className="ach-mandate-text">
          {ACH_MANDATE_CONSENT_TEXT_PREFIX}
          <a href="mailto:contactus@go4.io">contactus@go4.io</a>
          {ACH_MANDATE_CONSENT_TEXT_SUFFIX}
        </p>
      </div>
    }
    onSave={onAccept}
    confirmText="Agree & Continue"
    cancelText="Cancel"
  />
);

export default AchMandateModal;
